import _ from 'lodash';

import * as domain from '../../shared/types/domain';

type Scope = {
  orDie: (<T>(arg: T | null | undefined) => T) & {
    assert: <T>(arg: T | null | undefined) => asserts arg is T;
  };
  TLang: (typeof domain)['TLangEnum'];
  TExercise: (typeof domain)['TExerciseEnum'];
  TDeckTemplate: (typeof domain)['TDeckTemplateEnum'];
};

const scope = {} as Scope;

const orDie = <T>(arg: T | null | undefined): T => {
  if (_.isNil(arg)) {
    throw new Error(`Argument isn't set`);
  }
  return arg;
};
orDie.assert = <T>(arg: T | null | undefined) => {
  orDie(arg);
};

scope.orDie = orDie as Scope['orDie'];

for (const key of ['TLang', 'TExercise', 'TDeckTemplate'] as const) {
  // @ts-ignore
  scope[key] = scope.orDie(domain[`${key}Enum`]);
}

Object.assign(globalThis, scope);

declare global {
  const orDie: {
    <T>(arg: T | null | undefined): T;
    assert: <T>(arg: T | null | undefined) => asserts arg is T;
  };

  // for _api & debug
  interface Window {
    CURRENT_WORD: TWord;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const If: React.FC<{ condition: any; children: React.ReactNode }>;
}
